import { render, staticRenderFns } from "./FinishTreatmentValidationModal.vue?vue&type=template&id=18446bcf&scoped=true"
import script from "./FinishTreatmentValidationModal.vue?vue&type=script&lang=js"
export * from "./FinishTreatmentValidationModal.vue?vue&type=script&lang=js"
import style0 from "./FinishTreatmentValidationModal.vue?vue&type=style&index=0&id=18446bcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18446bcf",
  null
  
)

export default component.exports